import { render, staticRenderFns } from "./TermoDesentranhamentoAssinarGenerico.vue?vue&type=template&id=34c52bf4"
import script from "./TermoDesentranhamentoAssinarGenerico.vue?vue&type=script&lang=js"
export * from "./TermoDesentranhamentoAssinarGenerico.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports